import { Action } from '@ngrx/store';
import { ClientRole } from '@model';

export enum ManagerRolesActionTypes {
  ManagerRolesLoadData = '[ManagerRoles] Load data',
  ManagerRolesLoadSuccess = '[ManagerRoles] Load success',
  ManagerRolesLoadFail = '[ManagerRoles] Load fail'
}

export class ManagerRolesLoadData implements Action {
  readonly type = ManagerRolesActionTypes.ManagerRolesLoadData;
  constructor(public payload: number) {}
}

export class ManagerRolesLoadSuccess implements Action {
  readonly type = ManagerRolesActionTypes.ManagerRolesLoadSuccess;
  constructor(public payload: ClientRole[]) {}
}

export class ManagerRolesLoadFail implements Action {
  readonly type = ManagerRolesActionTypes.ManagerRolesLoadFail;
  constructor(public payload: any) {}
}

export type ManagerRolesActions = ManagerRolesLoadData | ManagerRolesLoadSuccess | ManagerRolesLoadFail;
